<template>
	<div class="myPages-dropdownS header-sticky" style="font-size:15px;margin-bottom:10px;">
		<span style="color:#4fa4ff;">{{p_title}}</span>
		<hr />
		<div class="filter-dropdown--content">
			<filter-accordion v-for="(page) in d_appPageItems" :p_title="page.name" :p_property="page" :key="`${page}-Page`">
				<div v-if="page.elements.length>0" class="myPages-selection" >
					<template>
						<label v-for="(item) in page.elements" :key="`${page}-${item}`">
							<span class="filter-selection--wrapper">
								<input v-if="page.name=='Home'" :id="`${page.name}-${item}`" :key="`${page.name}-${item}`" size="sm" type="checkbox" :checked="m_checkPageElement(page.name,item)" @change="m_pageChange($event,page.name,item)"></input>
								<input v-else :id="`${page.name}-${item}`" :key="`${page.name}-${item}`" size="sm" type="checkbox" disabled checked @change="m_pageChange($event,page.name,item)"></input>
								<span class="filter-selection--label">{{item}}</span>
							</span>
						</label>
					</template>
				</div>
			</filter-accordion>
		</div>
	</div>
</template>
<script> 
    import FilterAccordion from './KT-FilterAccordion.vue';
	import util, {fn_saveUserOpts,kbdpAlert} from "@/utils/util.js";
	import {refData} from "@/utils/ref-data.js";
	import {fn_saveAppUserSetting,fn_simpleSearch,settings as api} from "@/utils/api.js";
	import { eventBus } from '@/main';
    export default {
        name: 'myPages-settings',
        components: {
            "filter-accordion": FilterAccordion
        },
        props: {
        p_title:String,
		p_save:Boolean,
		p_appUserId:Number,
		p_settingData:Object
		},
        data() {
            return {
                d_openFilter: false,
				d_userEnabledPages:this.p_settingData.filter(s=>s.appUserId==this.p_appUserId)[0].enabledPages?.enabled,
				d_userAvailablePages:this.p_settingData.filter(s=>s.appUserId==this.p_appUserId)[0].enabledPages?.available,
				d_userPermissions:this.p_settingData.filter(s=>s.appUserId==this.p_appUserId)[0].permissions,
				d_pageChanges:0,
				d_changeCount:0,
				d_appPageItems:[
						{name:"Home",
						elements:[
								"Address Book",
								"Accounts",
								"Account Activities",
								"Calendar",
								"Calendar Activities",
								"Meetings",
								"Competitors",
								"Contacts",								
								"Create New",
								"Dashboard",
								"Opportunities",
								"Opportunity Activities",
								"My Pages",
								"Projects",
								"Project Activities",
								"Sales Forecasting",
								"Reenue Forecasting",
								"Staffing Management",
								"Team Members",
								"Team Chat",								],
						open:false
						},
						{name:"Calendar",
						elements:["Add",
							"Activities",
							],
						open:false
						},
						{name:"Sales Forecasting",
						elements:["Add Monthly Goals",
								"Add Quarterly Goals",
								"Add Company's Monthly Goals",
								"Add Company's Quarterly Goals",
								],
								open:false
						},
						{name:"Opportunities",
						elements:["Activities",
									"Create New",
									"Edit",
									"Clone",
									"Documents",
									"Decision",
									"Business Insight",
									"Debrief",
									"Bid Form",
									"Team Build"
									],
						open:false
						},
						{
						name:"Projects",
						elements:["Activities",
									"Clone",
									"Create New",
									"Edit",
									"Documents",
									"Busines Insight",
									"Debrief"
									],
						open:false
						},
						{
						name:"Accounts",
						elements:["Activities",
								"Edit",
								"Clone",
								"Create New",
								"Documents",
								"Related",
							],
						open:false
						},
						{name:"Competitors",
						elements:[
								"Create New",
								"Edit",
								"Related"
								],
						open:false
						},
						{name:"Contacts",
						elements:[
							"Create New",
							"Edit",
							"Related",
							],
						open:false
						},
						{name:"Team Members",
						elements:["Workload Management",
								"Create New",
								"Edit",
								"Related",
								],
						open:false
						}
					],
            }
        },
		created() {
		console.log('In MyPagesSetting');
				console.log(this.p_settingData);
				console.log(this.d_userAvailablePages);
				console.log(this.d_userEnabledPages);
		
				if(!this.d_userAvailablePages)
					this.d_userAvailablePages=
						{Home:[ "Admin",
								"Address Book",
								"Accounts",
								"Account Activities",
								"Calendar",
								"Calendar Activities",
								"Meetings",
								"Competitors",
								"Contacts",								
								"Create New",
								"Dashboard",
								"Opportunities",
								"Opportunity Activities",
								"Options",
								"Projects",
								"Project Activities",
								"Sales Forecasting",
								"Reenue Forecasting",
								"Settings",
								"Staffing Management",
								"Team Members",
								"Team Chat",
								"My Pages"
								],
					Calendar:["Add",
								"Activities"
								],
					"Sales Forecasting":["Add Monthly Goals",
										"Add Quarterly Goals",
										"Add Company's Monthly Goals",
										"Add Company's Quarterly Goals",
										],
					Opportunities:["Activities",
									"Business Insight",
									"Bid Form",
									"Clone",
									"Create New",
									"Debrief",
									"Decision",
									"Documents",
									"Edit",
									"Team Build"
									],
					Projects:["Activities",
									"Clone",
									"Create New",
									"Documents",
									"Edit",
									"Busines Insight",
									"Debrief"
									],
					Accounts:["Activities",
								"Create New",
								"Clone",
								"Documents",
								"Edit",
								"Related",
									],
					Competitors:["Create New",
								"Edit",
								"Related"
									],
					Contacts:[	"Address Book",
								"Create New",
								"Edit",
								"Related",
									],
					"Team Members":[
									"Create New",
									"Edit",
									"Related",
									"Workload Management",
									]
		};
		
		if(!this.d_userEnabledPages) this.d_userEnabledPages=this.d_userAvailablePages;
		},
        mounted() {},
        computed: {},
        methods: {
		m_checkPage(page){	return this.d_userAvailablePages['Home'].includes(page);},
		m_checkPageElement(page,e){	return this.d_userAvailablePages[page]?.includes(e);},					
		m_pageChange(e,page,i){

					var index;
					var pageIndex;
					this.d_changeCount++;
					this.d_pageChanges++;
					
					if(e.target.checked){		 
							
							if(!this.d_userAvailablePages[page].includes(i)) this.d_userAvailablePages[page].push(i);
							
							let pageObj=this.d_appPageItems.filter(p=>p.name==i)[0];
							if(pageObj) this.d_userAvailablePages[i]=[...pageObj.elements];
	
					}
					else {		index=this.d_userAvailablePages[page].indexOf(i);
								if(index>-1) this.d_userAvailablePages[page].splice(index,1);
								
								index=this.d_userEnabledPages[page].indexOf(i);
								if(index>-1) this.d_userEnabledPages[page].splice(index,1);			
								
								if(page=='Home' && this.d_userAvailablePages[i]){ 
									this.d_userAvailablePages[i].length=0;
									pageIndex=this.d_appPageItems.findIndex(p=>p.name==i);
									if(pageIndex>-1) this.d_appPageItems[pageIndex].open=false;
									}
						}
					
					let settingData = {available:this.d_userAvailablePages,enabled:this.d_userEnabledPages};
					fn_saveAppUserSetting({appUserId:this.p_appUserId,category:'pagePermissions',prop:'enabledPages',value:settingData});

		},	
		m_openClick(e,idx){this.d_appPageItems[idx].open = !this.d_appPageItems[idx].open; 
							e.stopPropagation();
							},
		m_capitalize(word){return word.replace(/^./, (x) => x.toUpperCase());},
		m_saveUserOpts(){
		
		/*
		let permissions=this.d_userPermissions;
		console.log('In m_saveUserOpts');
		console.log('permissions')
		console.log(permissions);
		
		if(permissions){
			var index;
			
			index=this.d_userAvailablePages["Home"].indexOf('Settings');
			if(!permissions.includes('editAppSettings')) {
				if(index>-1) this.d_userAvailablePages["Home"].splice(index,1);
			} else if(index==-1) this.d_userAvailablePages["Home"].push('Settings');

			index=this.d_userAvailablePages["Home"].indexOf('Dashboard'); 
			if(!permissions.includes('viewTeamMembersDashboard')) {
				if(index>-1) this.d_userAvailablePages["Home"].splice(index,1);
			} else if(index==-1) this.d_userAvailablePages["Home"].push('Dashboard');

			index=this.d_userAvailablePages["Home"].indexOf('Calendar');
			if(!permissions.includes('viewTeamMembersCalendar')) {
				console.log('no permissions.VTMC');
				if(index>-1) this.d_userAvailablePages["Home"].splice(index,1);
			} else if(index==-1) this.d_userAvailablePages["Home"].push('Calendar');
			
			index=this.d_userAvailablePages["Home"].indexOf('Sales Forecasting');
			if(!permissions.includes('setTeamMembersSalesGoals')) {
				console.log('no permissions.setTeamMembersSalesGoals');
				if(index>-1) this.d_userAvailablePages["Home"].splice(index,1);
			} else if(index==-1) this.d_userAvailablePages["Home"].push('Sales Forecasting');
	
		}
		*/
		
				let settingData = {available:this.d_userAvailablePages,enabled:this.d_userEnabledPages};
				console.log('Saving settingData');
				console.log(settingData);
				fn_saveAppUserSetting({appUserId:this.p_appUserId,category:'pagePermissions',prop:'enabledPages',value:settingData});
				this.$bvModal.show('savedAlert');
				this.$emit("saved"); 
		},
		m_refresh(){ 
					let settingData = {available:this.d_userAvailablePages,enabled:this.d_userEnabledPages};
					fn_saveAppUserSetting({appUserId:this.p_appUserId,category:'pagePermissions',prop:'enabledPages',value:settingData});
					setTimeout(()=>window.location.reload(),500);
					}
        },
watch: {
		p_save(nv,ov){
		if(nv) {
			this.m_saveUserOpts();
			}
	}
	
	}
 };
</script>
<style>
.filter-header {
        gap: 1rem;
    }
.filter-dropdown {
        position: absolute;
        top: 0rem;
        right: 0rem;
        width: 275px;
        background-color: #fff;
        border: 1px solid #6c757d;
        border-radius: 8px;
        transform: translate3d(-10px, 38px, 0px);;
        will-change: transform;
        z-index: 20;
    }
.btn.dropdown-toggle {
        margin: 0px
    }
.myPages-dropdown--header {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }
.filter-dropdown--content {
        max-height: 300px;
        overflow-y: scroll;
    }
.filter-selection--label {
        color: #4fa4ff;
    }
.myPages-dropdown--header .filter-dropdown--close {
        width: auto;
    }
.myPages-dropdown h3 {
        font-weight: bold;
        font-size: 1.15rem;
        padding: 1.25rem 1.25rem 0rem 1.25rem;
        margin-bottom: 0rem;
    }
.filter-dropdown button:not(.filter-dropdown--close) {
        width: 100%;
    }
.filter-dropdown button {
        font-size: 14px;
        font-weight: bold;
        padding: 1rem 1.25rem;
        border: 0px;
        background-color: transparent;
    }
.filter-dropdown button.btn-link {
        padding: 0.5rem;
        text-align: left;
    }
.filter-dropdown .icon {
        width: 1rem;
        margin-right: 0.5rem;
    }
.filter-dropdown .expand {
        background-color: rgb(245, 245, 245);
        padding: 1.25rem;
    }
.myPages-selection {
        display: flex;
        flex-direction: column;
        padding: 0.0rem 0rem;
        gap: 0.0rem;
        height: 100px;
        overflow-y: scroll;
        scrollbar-width: auto;
        scrollbar-color: #4fa4ff #ffffff;
    }
    .filter-selection.range,
    .filter-selection.date {
        height: auto;
        overflow-y: hidden;
    }
    .filter-selection label {
        width: 100%;
        font-size: 14px;
        display: flex;
        align-items: center;
    }
    .filter-selection input {
        margin-right: 0.75rem;
    }
    .filter-selection--wrapper {
        display: flex;
    }
    .apply-filters {
        gap: 0.5rem;
    }
    .applied-filter {
        display: flex;
        gap:0.25rem;
        background-color: #b8d8fa;
        color: #05488e;
        padding: 0.2rem 0.5rem;
        border: 0px;
        border-radius: 50px;
        font-size: 12px;
    }

    .applied-filter .icon {
        width: 0.75rem;
    }
    .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        top: auto;
        left: -10000px;
        overflow: hidden;
    }

    .close-icon {
        width: 1.25rem;
        height: 1.25rem;
    }
    /* ===== Scrollbar CSS ===== */
    .filter-selection::-webkit-scrollbar, .filter-dropdown--content::-webkit-scrollbar {
        width: 6px;
    }

    .filter-selection::-webkit-scrollbar-track, .filter-dropdown--content::-webkit-scrollbar-track {
        background: #ffffff;
    }

    .filter-selection::-webkit-scrollbar-thumb, .filter-dropdown--content::-webkit-scrollbar-thumb {
        background-color: #4fa4ff;
        border-radius: 10px;
        border: 1px solid #ffffff;
    }

.btn-link {
	display:inline-block;
	//width: 100%;
	padding-bottom: 0.5em;
	text-align: left;
	}
.btn-100{
     width: 100%;
    }
hr {
    color: #ddd;
    background-color: #ddd;
    //height: 1px;
    border: none;
    max-width: 100%;
}
div.form-group {
		min-width: 300px;
		//display: flex;
		flex-wrap: wrap;
		color: #4fa4ff;
		> label {
			min-width: 130px;
			margin: auto 0;
			color: #4fa4ff;
		}
     }
.input-value {
			margin-right: 0.3em;
			opacity: 0.5;
			&:hover {
			opacity: unset;
				}
			}
.btn2
		{
		font-size: 1em;
		margin-left: 0.5em;
		margin-right: 0.5em;
		padding: 0em 0.3em;
		border: solid 0.001em;
		border-radius: 0.15em;
		//opacity: 0.3;
			&:hover {
			opacity: unset;
				}
	}
h3 {
  text-align: center;
}
.topright-close {
  float: right;
  cursor: pointer;
  font-size: 28px;
}
.topright-close:hover {color: red;}
svg.fa-check-circle {
				font-size: 0.8em;
				color: #28a745; 
				background-color: white; 
				&:hover {
					opacity: 0.8;
						}
	}
.myPages-dropdownS {
        position: absolute;
        top: 0rem;
        right: 0rem;
        //width: 250px;
        background-color: #fff;
        //border: 1px solid #6c757d;
		border:none;
        //border-radius: 8px;
        //transform: translate3d(-10px, 38px, 0px);
        will-change: transform;
        z-index: 20;
    }
.myPages-dropdownS button:not(.filter-dropdown--close) {
        width: 100%;
		font-weight: normal;
		//color:#4fa4ff;
    }
.myPages-dropdownS button {
        font-size: 14px;
        font-weight: bold;
        padding: 0.5rem 1rem;
        border: 0px;
        background-color: transparent;
    }
.myPages-dropdownS button.btn-link {
        padding: 0.5rem;
        text-align: left;
		
    }
.myPages-dropdownS .icon {
        width: 1rem;
        margin-right: 0.5rem;
    }
.myPages-dropdownS .expand {
        background-color: rgb(245, 245, 245);
        padding: 1.25rem;
    }
.header-sticky{
	position:sticky;
	top:0px;
	margin-top:0px;
	background:white;
	z-index:9;
	}
hr{border: 0.1px solid;}
</style>